import { useRef, useState } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { conversation, phase } from "../state/store.js";
import { sendText } from "../hooks/useConversation.js";
import { hasOnScreenKeyboard } from "../utils/keyboardViewport.js";
import { AttachmentButton } from "./AttachmentButton.jsx";

export function Composer() {
  const [value, setValue] = useState("");
  const fieldRef = useRef(null);
  const conv = conversation.value;
  // Mientras el bot espera abonado/DNI, teclado numérico y placeholder guiado.
  const awaitingId = conv.state === "waiting_id" || conv.state === "awaiting_document_choice";

  // El composer NO se traba mientras el bot responde: el cliente puede mandar
  // varias frases cortas seguidas y el bridge las junta en un solo
  // procesamiento (buffer de debounce, igual que en WhatsApp). Trabarlo dejaba
  // el envío bloqueado ~3 s por mensaje y descartaba lo que se escribía en el
  // medio. El indicador de "escribiendo" es el que comunica que el bot está ocupado.
  const send = (raw) => {
    const text = String(raw || "").trim();
    if (!text || phase.value !== "ready") return;
    setValue("");
    sendText(text);
    // En el celular, cerrar el teclado al enviar: con el teclado abierto la
    // respuesta del bot entra en una franja de pantalla y queda cortada.
    if (hasOnScreenKeyboard()) fieldRef.current?.blur();
  };

  const submit = (e) => {
    e?.preventDefault?.();
    send(value);
  };

  // Enter envía (en el celular, la tecla dice "Enviar" por enterkeyhint);
  // Shift+Enter en desktop agrega un salto de línea.
  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing) submit(e);
  };

  // Algunos teclados de Android no mandan keydown de Enter en un textarea y
  // escriben el salto de línea directo: en el celular, eso también es enviar.
  const onInput = (e) => {
    const next = e.currentTarget.value;
    if (hasOnScreenKeyboard() && next.includes("\n")) {
      send(next.replace(/\n/g, " "));
      return;
    }
    setValue(next);
  };

  return (
    <form class="relative border-t border-white/10 bg-white/10 px-3 py-2 backdrop-blur safe-bottom" onSubmit={submit}>
      <div class="chat-col flex items-center gap-2">
      <AttachmentButton />
      {/* textarea y no input: Chrome en Android muestra sobre el teclado la
          barra de autocompletar (contraseñas, tarjetas, direcciones) para los
          input de un form, y le quitaba alto a la conversación. */}
      <textarea
        ref={fieldRef}
        rows={1}
        class="max-h-28 min-w-0 flex-1 resize-none rounded-3xl border border-transparent bg-white px-4 py-2.5 text-sm leading-5 text-flux-navy outline-none placeholder:text-slate-400 focus:border-flux-cyan-deep dark:bg-slate-800 dark:text-white dark:placeholder:text-slate-500"
        placeholder={awaitingId ? strings.composerPlaceholderId : strings.composerPlaceholder}
        inputMode={awaitingId ? "numeric" : "text"}
        autocomplete="off"
        autocorrect="on"
        enterkeyhint="send"
        value={value}
        onInput={onInput}
        onKeyDown={onKeyDown}
      />
      <button
        type="submit"
        disabled={!value.trim() || phase.value !== "ready"}
        class="rounded-full bg-flux-primary px-4 py-2.5 text-sm font-medium text-white active:bg-flux-primary-dark disabled:opacity-40"
      >
        {strings.send}
      </button>
      </div>
    </form>
  );
}
